// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ssIN","title":"styles_title__EM_52"};